import React, { useState } from "react";
import { Stack, Button } from "@mui/material";
import { useAuditoria } from "../contexts/AuditoriaContext";
import { useAuditoriaUtils } from "../hooks/useAuditoriaUtils";
import PercentIcon from "@mui/icons-material/Percent";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import ModalAumentarValores from "../modals/ModalAumentarValores";
import ModalOdontologosListas from "../modals/ModalOdontologosListas";
import ModalEditarListaHonorarios from "../modals/ModalEditarListaHonorarios";
import { ModeloGetUrlJson } from "../../ModeloCrud";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";

const ListasHonorariosActions = () => {
  const { selectedListaHonorarios } = useAuditoria();
  const [modalHonorariosOpen, setModalHonorariosOpen] = useState(false);
  const [modalOdontologosOpen, setModalOdontologosOpen] = useState(false);
  const [modalEditarListaHonorariosOpen, setModalEditarListaHonorariosOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);

  // Utilidades de auditoría

  const { handleAuditarOdontologo, handleAuditarPaciente } =
    useAuditoriaUtils();

  const isDisabled = !selectedListaHonorarios;
  const isEditing = selectedListaHonorarios;

  const handleImprimir = async () => {
    if (!selectedListaHonorarios) {
      toast.warning("Debe seleccionar una lista de honorarios primero.");
      return;
    }

    try {
      const id = selectedListaHonorarios.id;
      setLoading(true);
      const result = await ModeloGetUrlJson(
        "listas-precios-honorarios",
        id,
        "print-lista",
        null
      );
      setLoading(false);
      console.log("Resultado de imprimir lista:", result);
      if (result.error || !result.url) {
        toast.error("No se pudo generar el PDF.");
        return;
      }

      window.open(result.url, "_blank");
    } catch (error) {
      toast.error("Error al imprimir la lista.");
      console.error(error);
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      <Button
        startIcon={
          isEditing ? (
            <EditIcon sx={{ fontSize: 24 }} />
          ) : (
            <AddIcon sx={{ fontSize: 24 }} />
          )
        }
        variant="contained"
        onClick={() => setModalEditarListaHonorariosOpen(true)}
        sx={{
          width: 150,
          backgroundColor: "primary.main",
          ":hover": {
            bgcolor: "#475569",

            color: "white",
          },
          textTransform: "capitalize",
        }}
      >
        {isEditing ? "Editar" : "Agregar"}
      </Button>
      <Button
        startIcon={<PercentIcon sx={{ fontSize: 24 }} />}
        variant="contained"
        onClick={() => setModalHonorariosOpen(true)}
        disabled={isDisabled}
        sx={{
          width: 150,
          backgroundColor: "primary.main",
          ":hover": {
            bgcolor: "#475569",

            color: "white",
          },
          textTransform: "capitalize",
        }}
      >
        Aumentar
      </Button>
      <LoadingButton
        startIcon={<PrintIcon sx={{ fontSize: 24 }} />}
        variant="contained"
        onClick={handleImprimir}
        loading={loading} // El estado loading se controla con la variable isDisabled o cualquier otro estado que definas
        loadingPosition="start" // Muestra el icono de carga al principio del botón
        sx={{
          width: 150,
          backgroundColor: "primary.main",
          ":hover": {
            bgcolor: "#475569",
            color: "white",
          },
          textTransform: "capitalize",
        }}
      >
        Imprimir
      </LoadingButton>

      <Button
        startIcon={<i className="fa-solid fa-user-doctor"></i>} // ⬅️ corregido: class → className
        variant="contained"
        onClick={() => setModalOdontologosOpen(true)}
        disabled={isDisabled}
        sx={{
          width: 200,
          backgroundColor: "primary.main",
          ":hover": {
            bgcolor: "#475569",
            color: "white",
          },
          textTransform: "capitalize",
        }}
      >
        Odontólogos listas
      </Button>
      <ModalEditarListaHonorarios
        showModal={modalEditarListaHonorariosOpen}
        hideModal={() => setModalEditarListaHonorariosOpen(false)}
        listaRow={isEditing ? selectedListaHonorarios : null}
        afterSave={null}
      />
      <ModalAumentarValores
        showModal={modalHonorariosOpen && selectedListaHonorarios}
        hideModal={() => setModalHonorariosOpen(false)}
        listaRow={selectedListaHonorarios}
        afterSave={null}
      />
      <ModalOdontologosListas
        showModal={modalOdontologosOpen && selectedListaHonorarios}
        hideModal={() => setModalOdontologosOpen(false)}
        listaRow={selectedListaHonorarios}
        afterSave={null}
      />
    </Stack>
  );
};

export default ListasHonorariosActions;
